import { useEffect, useRef, useState, useContext } from 'react';

import { useParams } from 'react-router-dom';

import { AppContext } from '../scripts/context'

export default function Detail() {

    const { page } = useParams();
    const { item } = useParams();

    const itemPrice = useRef();

    const detailContainerRef = useRef();

    const mediaTopRef = useRef();
    const mediaBottomRef = useRef();

    const mediaFadeRunningRef = useRef(false);

    const mediaCurrentIndexRef = useRef(0);

    const {
    //MENU
        handleMenu,
    //CONTACT CONTAINER
        handleContactContainer,
    //WIDGET
        widgetState,
        setWidgetState,
        getWidgetWidthCorr,
    //CHECKOUT PANEL
        exRateChfUsdRef,
        cartItemLimitRef,
        setCartContent,
		setCheckoutPanelButtonState,
    //SCROLL
        getScrollPosition,
    //DETAIL
        detailMediaLoadedRef,
        detailItemActiveRef,
        detailWidgetState,
        setDetailWidgetState,
    //STYLE
        detailContainerStyleState,
        detailMediaTopStyleState,
        setDetailMediaTopStyleState,
        detailMediaBottomStyleState,
        setDetailMediaBottomStyleState,
        detailPlayButtonSvgStyleState,
        detailWidgetStyleState,
        detailControlsLeftSvgStyleState,
        detailControlsRightSvgStyleState,
        setDetailControlsRightSvgStyleState,
        detailControlsItemsContainerStyleState,
    } = useContext(AppContext);

    const [detailPlayButtonState, setDetailPlayButtonState] = useState(false);
    const [detailControlsSideState, setDetailControlsSideState] = useState(false);

    const [descriptionButtonFirstFillState, setDescriptionButtonFirstFillState] = useState("#333333");
    const [descriptionButtonSecondFillState, setDescriptionButtonSecondFillState] = useState("#333333");
    const [descriptionButtonThirdFillState, setDescriptionButtonThirdFillState] = useState("#333333");

    const [detailWidgetWidthCorrState, setDetailWidgetWidthCorrState] = useState(getWidgetWidthCorr());
    const [detailWidgetColorState, setDetailWidgetColorState] = useState("standard");
    const [detailWidgetButtonFillState, setDetailWidgetButtonFillState] = useState("#00000066");

    const detailWidgetStateRef = useRef(false);
    detailWidgetStateRef.current = detailWidgetState;
    const widgetStateRef = useRef(false);
    widgetStateRef.current = widgetState;

    const [detailWidgetAddToCartCountState, setDetailWidgetAddToCartCountState] = useState(1);

    const contentMap = {
        home: {
            nils: {
                ref: "nils",
                srcs: ["/media/njbdesign_nils_0.webp"],
                pos: ["50% 20%"],
                title: "nils",
                text: <div id="description_text">Nils Badertscher,<br/>founder of <span className="nw">njb design<sup>®</sup></span>.</div>,
                links: []
            }
        },
        digital: {
            opp2000: {
                ref: "opp2000",
                srcs: ["/media/osterwalder_opp2000_0.mp4", "/media/osterwalder_opp2000_0.webp"],
                pos: ["50% 50%", "50% 50%"],
                title: "opp 2000",
                text: <div id="description_text">Fully interactive VR application and 3D animation of the <span className="nw">Osterwalder AG</span> electric sintering press <span className="nw">OPP 2000.</span></div>,
                links: ["https://www.osterwalder.com"]
            },
            fabia: {
                ref: "fabia",
                srcs: ["/media/meyerburger_fabia_0.mp4", "/media/meyerburger_fabia_1.webp"],
                pos: ["50% 50%", "25% 50%"],
                title: "fabia",
                text: <div id="description_text">3D animation of the <span className="nw">Meyer Burger AG</span> <span className="nw">FABiA<sup>®</sup> 4.1</span> PERx plasma coating line for photovoltaic cells.</div>,
                links: ["https://www.meyerburger.com"]
            },
            jetx: {
                ref: "jetx",
                srcs: ["/media/suss_jetx_m_0.mp4", "/media/suss_jetx_s_0.mp4", "/media/suss_jetx_m_1.webp"],
                pos: ["40% 50%", "40% 50%", "50% 50%"],
                title: "jet x",
                text: <div id="description_text">3D animations of the <span className="nw">SÜSS MicroTec SE</span> industrial inkjet printers <span className="nw">JETx M and S.</span></div>,
                links: ["https://www.suss.com"]
            },
            dw291: {
                ref: "dw291",
                srcs: ["/media/peterwolters_dw291_0.mp4", "/media/peterwolters_dw291_0.webp"],
                pos: ["50% 50%", "50% 50%"],
                title: "dw 291",
                text: <div id="description_text">3D animation of the <span className="nw">Lapmaster Wolters GmbH</span> multiwire saw <span className="nw">DW 291.</span></div>,
                links: ["https://lapmaster-wolters.de"]
            }
        },
        games: {
            xthrust: {
                ref: "xthrust",
                srcs: ["/media/njbdesign_xthrust_0.mp4", "/media/njbdesign_xthrust_1.webp", "/media/njbdesign_xthrust_2.webp"],
                pos: ["50% 50%", "50% 50%", "58% 50%"],
                title: "xthrust",
                text: <div id="description_text">XTHRUST is an experimental multiplayer racing game with rocket drones. It was developed as showcase project by three dedicated engineers and published by <span className="nw">njb design<sup>®</sup></span>.</div>,
                links: ["https://xthrust.com", "https://store.steampowered.com/app/1527080/XTHRUST/", "https://discord.com/invite/jgPeNnk"]
            },
            ammomaker: {
                ref: "ammomaker",
                srcs: ["/media/njbdesign_ammomaker_0.webp", "/media/njbdesign_ammomaker_1.webp"],
                pos: ["10% 50%", "50% 50%"],
                title: "ammo maker",
                text: <div id="description_text">Ammo Maker is a popular framework to produce gunpowder and ammunition in survival games. It provides abstracted processes and recipes starting with basic resources and tools and is available as free modification.</div>,
                links: ["https://steamcommunity.com/sharedfiles/filedetails/?id=2788256295", "https://discord.com/invite/GatzBH78Rj", "https://www.paypal.com/ncp/payment/B25MW3LUV22PN"]
            }
        },
        design: {
            curve: {
                ref: "curve",
                srcs: ["/media/njbdesign_curve_0.webp"],
                pos: ["40% 50%"],
                title: "curve",
                text: <div id="description_text">Curve is a slim sideboard, featuring a laminated wooden frame and a translucent acrylic glass element, that reimagines stacked compartments and forms a continuous pattern across multiple units.</div>,
                links: []
            },
            wristband: {
                ref: "wristband",
                srcs: ["/media/njbdesign_wristband_0.webp", "/media/njbdesign_wristband_1.webp", "/media/njbdesign_wristband_2.webp"],
                pos: ["50% 50%", "50% 50%", "50% 50%"],
                title: "wristband",
                text: <div id="description_text">Limited-edition wristband for the xthrust game project, featuring lava stone beads and custom platinum parts, made in a die-cast process utilizing 3D-printed wax models for mold formation.</div>,
                links: []
            }
        },
        store: {
            njbdesign_sticker: {
                ref: "njbdesign_sticker",
                srcs: ["/media/njbdesign_sticker_0.webp"],
                pos: ["50% 50%"],
                title: "njb design sticker",
                text: <div id="description_text"><span className="nw">njb design<sup>®</sup></span> logo as multi-color vinyl sticker. Easy to orient and apply with carrier foil.<div id="description_text_detail">180 x 30 mm | Oracal 751</div><div id="description_text_price">{"CHF " + itemPrice.current}<div id="description_text_price_detail">{"~USD " + (itemPrice.current * exRateChfUsdRef.current).toFixed(2)}</div></div></div>,
                links: ["quantity"],
                colors: ["standard"],
                price: 4.99,
                weight: 2,
                htsclass: "3919.90.50.60",
                packing: "c5"
            },
            ammomaker_birdfeeder_modelkit: {
                ref: "ammomaker_birdfeeder_modelkit",
                srcs: ["/media/njbdesign_ammomaker_birdfeeder_modelkit_0.webp", "/media/njbdesign_ammomaker_birdfeeder_modelkit_1.webp", "/media/njbdesign_ammomaker_birdfeeder_modelkit_2.webp", "/media/njbdesign_ammomaker_birdfeeder_modelkit_3.webp", "/media/njbdesign_ammomaker_birdfeeder_modelkit_4.webp", "/media/njbdesign_ammomaker_birdfeeder_modelkit_5.webp"],
                pos: ["50% 50%", "48.5% 50%", "67% 50%", "50% 50%", "50% 50%", "50% 50%"],
                title: "bird feeder modelkit",
                text: <div id="description_text">Bird feeder from Ammo Maker as 1:20 model kit. 3d-printed with selective laser sintering (SLS).<div id="description_text_detail">50 x 50 x 113 mm | PA12 (nylon)</div><div id="description_text_price">{"CHF " + itemPrice.current}<div id="description_text_price_detail">{"~USD " + (itemPrice.current * exRateChfUsdRef.current).toFixed(2)}</div></div></div>,
                links: ["quantity", "https://njb.design/share/manuals/njbdesign_ammomaker_birdfeeder_modelkit_manual.pdf"],
                colors: ["standard"],
                price: 24.99,
                weight: 25,
                htsclass: "9503.00.00.90",
                packing: "d14"
            },
            ammomaker_sticker: {
                ref: "ammomaker_sticker",
                srcs: ["/media/njbdesign_ammomaker_sticker_0.webp", "/media/njbdesign_ammomaker_sticker_1.webp"],
                pos: ["50% 50%", "50% 50%"],
                title: "ammo maker sticker",
                text: <div id="description_text">Ammo Maker logo as vinyl sticker available in silver and black. Easy to orient and apply with carrier foil.<div id="description_text_detail">180 x 30 mm | Oracal 751</div><div id="description_text_price">{"CHF " + itemPrice.current}<div id="description_text_price_detail">{"~USD " + (itemPrice.current * exRateChfUsdRef.current).toFixed(2)}</div></div></div>,
                links: ["color"],
                colors: ["silver", "black"],
                price: 2.99,
                weight: 2,
                htsclass: "3919.90.50.60",
                packing: "c5"
            },
            xthrust_sticker: {
                ref: "xthrust_sticker",
                srcs: ["/media/njbdesign_xthrust_sticker_0.webp", "/media/njbdesign_xthrust_sticker_1.webp"],
                pos: ["50% 50%", "50% 50%"],
                title: "xthrust sticker",
                text: <div id="description_text">XTHRUST logo as vinyl sticker available in silver and black. Easy to orient and apply with carrier foil.<div id="description_text_detail">180 x 30 mm | Oracal 751</div><div id="description_text_price">{"CHF " + itemPrice.current}<div id="description_text_price_detail">{"~USD " + (itemPrice.current * exRateChfUsdRef.current).toFixed(2)}</div></div></div>,
                links: ["color"],
                colors: ["silver", "black"],
                price: 2.99,
                weight: 2,
                htsclass: "3919.90.50.60",
                packing: "c5"
            }
        }
    };

    const pageKeyMap = {
        undefined: "home",
        about: "home"
    };

    const pageKey = pageKeyMap[page] ?? page;
    const itemKey = !item && contentMap[pageKey][detailItemActiveRef.current] ? detailItemActiveRef.current : !contentMap[pageKey][detailItemActiveRef.current] ? Object.values(contentMap[pageKey])[0].ref : item;

    const contentData = contentMap[pageKey][itemKey];

    mediaCurrentIndexRef.current = detailItemActiveRef.current !== contentData.ref ? 0 : mediaCurrentIndexRef.current;

    detailItemActiveRef.current = contentData.ref;
    itemPrice.current = contentData.price ? contentData.price : 0;

    const mediaIndexTopRef = useRef(0);
    const mediaIndexBottomRef = useRef(0);

    if (!contentData.srcs[mediaIndexBottomRef.current]) { mediaIndexBottomRef.current = 0 };
    if (!contentData.srcs[mediaIndexTopRef.current]) { mediaIndexTopRef.current = 0 };

    const detailPlayButton =    <svg version="1.1" id="detail_play_button_svg" style={detailPlayButtonSvgStyleState} xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 96 96" preserveAspectRatio="xMidYMid meet" pointerEvents="none">
                                    <path id="play_bg" fill="#000000" opacity="0.75" d="M68.167,81.938C66.242,85.272,61.517,88,57.667,88H15c-3.85,0-7-3.15-7-7V55c0-3.85,1.575-9.728,3.5-13.063l16.094-27.875C29.519,10.728,34.244,8,38.094,8H81c3.85,0,7,3.15,7,7v25.586c0,3.85-1.575,9.728-3.5,13.063L68.167,81.938z"/>
                                    <path id="play" fill="#FFFFFF" d="M36,35.524c0-3.3,2.338-4.65,5.196-3L62.804,45c2.858,1.65,2.858,4.35,0,6L41.196,63.476c-2.858,1.65-5.196,0.3-5.196-3V35.524z"/>
                                </svg>;

    const detailDescriptionIcons = {
        steam_svg:

        <path id="steam" fill="#FFFFFF" d="M17.538,11.613c0,0.028,0,0.055,0.001,0.081l-4.014,5.826c-0.65-0.028-1.304,0.083-1.923,0.339
	        c-0.272,0.109-0.527,0.246-0.767,0.406l-8.814-3.627c0,0-0.205,3.353,0.644,5.851l6.231,2.57c0.313,1.397,1.272,2.621,2.688,3.214
	        c2.316,0.966,4.986-0.135,5.949-2.451c0.25-0.604,0.368-1.238,0.35-1.872l5.744-4.102c0.046,0.002,0.095,0.002,0.142,0.002
	        c3.437,0,6.231-2.8,6.231-6.237c0-3.438-2.794-6.238-6.231-6.238C20.333,5.375,17.538,8.175,17.538,11.613z M16.575,23.422
	        c-0.745,1.787-2.803,2.637-4.59,1.893c-0.824-0.344-1.447-0.973-1.807-1.725l2.028,0.842c1.32,0.549,2.83-0.076,3.379-1.393
	        c0.548-1.321-0.074-2.832-1.391-3.383l-2.098-0.869c0.81-0.306,1.729-0.316,2.588,0.041c0.867,0.361,1.538,1.039,1.896,1.904
	        C16.936,21.601,16.934,22.559,16.575,23.422 M23.77,15.77c-2.289,0-4.151-1.865-4.151-4.157c0-2.291,1.862-4.157,4.151-4.157
	        s4.152,1.866,4.152,4.157C27.922,13.905,26.059,15.77,23.77,15.77 M20.659,11.606c0-1.725,1.396-3.125,3.117-3.125
	        c1.723,0,3.119,1.4,3.119,3.125c0,1.725-1.396,3.122-3.119,3.122C22.056,14.729,20.659,13.331,20.659,11.606z"/>,

        discord_svg:

        <path id="discord" fill="#FFFFFF" d="M26.548,8.446c-3.452-2.59-6.735-2.516-6.735-2.516l-0.336,0.381
            c4.076,1.249,5.971,3.044,5.971,3.044c-2.494-1.367-4.939-2.037-7.216-2.301c-1.728-0.193-3.38-0.146-4.842,0.049
            c-0.144,0-0.263,0.023-0.407,0.05c-0.84,0.067-2.877,0.383-5.442,1.509c-0.889,0.41-1.416,0.695-1.416,0.695s1.99-1.892,6.304-3.139
            l-0.24-0.287c0,0-3.283-0.072-6.736,2.516c0,0-3.452,6.258-3.452,13.978c0,0,2.015,3.478,7.313,3.646c0,0,0.887-1.08,1.605-1.99
            c-3.044-0.911-4.195-2.828-4.195-2.828s0.24,0.166,0.671,0.406c0.024,0.023,0.047,0.049,0.095,0.073
            c0.073,0.048,0.146,0.068,0.216,0.119c0.599,0.335,1.199,0.597,1.75,0.814c0.983,0.38,2.159,0.766,3.523,1.028
            c1.798,0.334,3.907,0.457,6.208,0.023c1.127-0.193,2.277-0.526,3.477-1.031c0.84-0.311,1.773-0.766,2.758-1.414
            c0,0-1.2,1.966-4.34,2.853c0.719,0.91,1.582,1.943,1.582,1.943C27.963,25.899,30,22.422,30,22.422
            C30,14.702,26.548,8.446,26.548,8.446z M11.519,20.193c-1.342,0-2.444-1.199-2.444-2.658c0-1.466,1.077-2.663,2.444-2.663
            c1.368,0,2.469,1.198,2.444,2.663C13.962,18.994,12.885,20.193,11.519,20.193z M20.268,20.193c-1.342,0-2.444-1.199-2.444-2.658
            c0-1.466,1.077-2.663,2.444-2.663c1.369,0,2.445,1.198,2.445,2.663C22.712,18.994,21.636,20.193,20.268,20.193z"/>,

        paypal_svg:

        <path id="paypal" fill="#FFFFFF" d="M23.175,8.112c0,3.292-3.037,7.176-7.634,7.176h-4.428l-1.25,7.973H4.36L7.67,2h8.915
	        c3.002,0,5.363,1.673,6.233,3.999C23.07,6.674,23.19,7.392,23.175,8.112z M27.564,15.649c-0.607,3.686-3.797,6.387-7.532,6.378
	        h-3.075L15.677,30h-5.472l2.126-13.288h3.209c5.338,0,8.184-3.549,8.914-7.164C26.713,10.713,27.969,13.058,27.564,15.649
	        L27.564,15.649z"/>,

        xthrust_svg:

        <path id="xthrust" fill="#FFFFFF" d="M16,14.5c2.667,0,10.056-9.583,10.056-9.583H30V5.25C30,6.917,18.667,14.046,18.667,16
	        C18.667,17.953,30,25.084,30,26.75v0.334h-3.944c0,0-7.389-9.584-10.056-9.584S5.944,27.084,5.944,27.084H2V26.75
	        C2,25.084,13.333,17.953,13.333,16C13.333,14.046,2,6.917,2,5.25V4.917h3.944C5.944,4.917,13.333,14.5,16,14.5z"/>,

        cart_svg:

        <path id="cart" fill="#FFFFFF" d="M2,10.38l9.91,9.91c0.458,0.458,1.36,0.83,2.006,0.83h4.797c0.646,0,1.439-0.458,1.763-1.018
	        l5.614-9.723H2z M9.081,23.04c0,1.339-1.084,2.42-2.42,2.42s-2.42-1.081-2.42-2.42c0-1.336,1.084-2.42,2.42-2.42
	        S9.081,21.704,9.081,23.04z M25.933,23.04c0,1.338-1.084,2.42-2.42,2.42s-2.42-1.082-2.42-2.42c0-1.336,1.084-2.42,2.42-2.42
	        S25.933,21.704,25.933,23.04z M30,8.938l-2.213-2.212c-0.103-0.104-0.304-0.187-0.449-0.187h-1.071
	        c-0.144,0-0.321,0.102-0.394,0.227l-1.252,2.172H30z"/>,

        manual_svg:

        <path id="manual" fill="#FFFFFF" d="M6,24c-1.103,0-2-0.896-2-2V10c0-1.103,0.897-2,2-2h10l8.087-4.654v15.93L16,24H6z M26,8
	        c1.104,0,2,0.897,2,2v12c0,1.104-0.896,2-2,2h-8.071l7.158-4.109V8H26z M25.087,6V1.728L17.566,6H6c-2.2,0-4,1.8-4,4v12
	        c0,2.2,1.8,4,4,4h20c2.2,0,4-1.8,4-4V10c0-2.2-1.801-4-4-4H25.087z M10,9.5c0.898,0,1.625,0.727,1.625,1.625S10.897,12.75,10,12.75
	        c-0.897,0-1.625-0.727-1.625-1.625S9.102,9.5,10,9.5z M6.75,13.833c0,0,1.35,0,3.25,0c2.167,0,2.167,0,2.167,1.085
	        c0,1.817-1.084,3.836-1.084,5.417c0,1.081,2.167,1.081,2.167,1.081V22.5c0,0-1.35,0-3.25,0c-2.167,0-2.167,0-2.167-1.084
	        c0-1.816,1.084-3.836,1.084-5.416c0-1.083-2.167-1.083-2.167-1.083L6.75,13.833L6.75,13.833z M17.25,21.855l6.087-3.515
	        c0.239-0.138,0.321-0.443,0.183-0.683c-0.138-0.239-0.444-0.322-0.683-0.183L16.75,20.99c-0.239,0.138-0.321,0.443-0.183,0.683
	        c0.092,0.16,0.261,0.25,0.433,0.25C17.085,21.923,17.171,21.901,17.25,21.855z M17.25,18.855l6.087-3.514
	        c0.239-0.138,0.321-0.444,0.183-0.683c-0.138-0.24-0.444-0.32-0.683-0.183L16.75,17.99c-0.239,0.138-0.321,0.443-0.183,0.683
	        c0.092,0.16,0.261,0.25,0.433,0.25C17.085,18.923,17.171,18.901,17.25,18.855z M17.25,15.856l6.087-3.514
	        c0.239-0.138,0.321-0.444,0.183-0.683c-0.138-0.241-0.444-0.321-0.683-0.183L16.75,14.99c-0.239,0.138-0.321,0.444-0.183,0.683
	        c0.092,0.161,0.261,0.25,0.433,0.25C17.085,15.923,17.171,15.901,17.25,15.856z M17.25,12.856l6.087-3.514
	        c0.239-0.138,0.321-0.444,0.183-0.683c-0.138-0.24-0.444-0.321-0.683-0.183L16.75,11.99c-0.239,0.138-0.321,0.444-0.183,0.683
	        c0.092,0.161,0.261,0.25,0.433,0.25C17.085,12.923,17.171,12.901,17.25,12.856z M17.25,9.856l6.087-3.514
	        c0.239-0.138,0.321-0.444,0.183-0.683c-0.138-0.241-0.444-0.321-0.683-0.183L16.75,8.99c-0.239,0.138-0.321,0.444-0.183,0.683
	        c0.092,0.161,0.261,0.25,0.433,0.25C17.085,9.923,17.171,9.901,17.25,9.856z"/>,

        external_svg:

        <path id="external" fill="#FFFFFF" d="M24,18v4c0,1.103-0.897,2-2,2H6c-1.103,0-2-0.897-2-2v-8c0-1.103,0.897-2,2-2h12v-2H6
	        c-2.2,0-4,1.8-4,4v8c0,2.2,1.8,4,4,4h16c2.2,0,4-1.8,4-4v-4H24z M27.663,9.751l-1.414-1.414l-8.956,8.956l1.414,1.414L27.663,9.751z
	         M28.452,11.779L30,6l-5.779,1.548L28.452,11.779z"/>

    };

    function updateDetailControlsSideState() {

        if (contentData.srcs.length > 1 && (window.innerWidth >= 580 || (window.innerWidth < 580 && detailWidgetStateRef.current === false && widgetStateRef.current === false))) {
            setDetailControlsSideState(true);
        } else {
            setDetailControlsSideState(false);
        };

        if (window.visualViewport.height < 560) {
            setDetailControlsRightSvgStyleState(prevState => ({
                ...prevState,
                right: 440 - window.visualViewport.height * 0.29 + "px",
            }));
        } else {
            setDetailControlsRightSvgStyleState(prevState => ({
                ...prevState,
                right: "0px",
            }));
        }

    };

    //Background media functions
    function handleDetailOnLoad() {

        detailMediaLoadedRef.current = true;

    };

    function getMediaNextIndex(currentIndex) {

        if (currentIndex + 1 > contentData.srcs.length - 1) {

            return 0;

        } else {

            return currentIndex + 1;

        };

    };

    function getMediaPreviousIndex(currentIndex) {

        if (currentIndex - 1 < 0) {

            return contentData.srcs.length - 1;

        } else {

            return currentIndex - 1;

        };

    };

    function goToNextMedia() {

        if (mediaFadeRunningRef.current === false) {

            mediaFadeRunningRef.current = true;
            updateMedia(getMediaNextIndex(mediaIndexBottomRef.current));
            setDetailWidgetState(false);
            setWidgetState(false);

            if (page === "store") {
                setDetailWidgetColorState(contentData.colors[mediaCurrentIndexRef.current]);
            };

        };

    };

    function goToPreviousMedia() {

        if (mediaFadeRunningRef.current === false) {

            mediaFadeRunningRef.current = true;
            updateMedia(getMediaPreviousIndex(mediaIndexBottomRef.current));
            setDetailWidgetState(false);
            setWidgetState(false);

            if (page === "store") {
                setDetailWidgetColorState(contentData.colors[mediaCurrentIndexRef.current]);
            };

        };

    };

    function goToMediaIndex(index, from) {

        if (mediaFadeRunningRef.current === false) {

            mediaFadeRunningRef.current = true;
            updateMedia(index);

            if (page === "store" && from === "widget") {

                setDetailWidgetColorState(contentData.colors[index]);

            } else if (page === "store") {
                
                setDetailWidgetColorState(contentData.colors[index]);
                setDetailWidgetState(false);
                setWidgetState(false);

            } else {

                setDetailWidgetState(false);
                setWidgetState(false);

            };
        
        };

    };

    function updatePlayButton() {
        let mediaType = contentData.srcs[mediaIndexBottomRef.current].split('.').pop().toLowerCase();
        if (mediaType !== "mp4") {
            setDetailPlayButtonState(false);
        } else {
            setDetailPlayButtonState(true);
        };
    };

    function updateMedia(newIndex) {

        //set new media on bottom layer
        mediaIndexBottomRef.current = newIndex;
        setDetailMediaBottomStyleState(prevState => ({
            ...prevState,
            objectPosition: contentData.pos[mediaIndexBottomRef.current],
        }));

        updatePlayButton();

        //fade out top layer
        let detailMediaTopOpacity = 1;
        let detailMediaTopOpacityTarget = 0;
        let detailMediaTopAnimStep = -0.025;

        let intervalDetailMediaTopFadeOut = setInterval(detailMediaTopFadeOutInt, 5);
        function detailMediaTopFadeOutInt() {
            if (detailMediaTopOpacity !== detailMediaTopOpacityTarget) {
                detailMediaTopOpacity = Math.max(detailMediaTopOpacity + detailMediaTopAnimStep, detailMediaTopOpacityTarget);
                setDetailMediaTopStyleState(prevState => ({
                    ...prevState,
                    opacity: detailMediaTopOpacity,
                }));
            } else {
                clearInterval(intervalDetailMediaTopFadeOut);

                //set new media on top layer
                mediaIndexTopRef.current = mediaIndexBottomRef.current;
                setDetailMediaTopStyleState(prevState => ({
                    ...prevState,
                    objectPosition: contentData.pos[mediaIndexTopRef.current],
                }));
        
                //show top layer
                setTimeout(function() {
                    setDetailMediaTopStyleState(prevState => ({
                        ...prevState,
                        opacity: 1,
                    }));

                    mediaFadeRunningRef.current = false;

                }, 30);

            };

        };

    };

    //Description buttons and detail widget functions
    function getDetailDescriptionIcon(buttonNr) {
        if (contentData.links[buttonNr].includes("steampowered.com") || contentData.links[buttonNr].includes("steamcommunity.com")) {
            return detailDescriptionIcons.steam_svg
        } else if (contentData.links[buttonNr].includes("discord.com")) {
            return detailDescriptionIcons.discord_svg
        } else if (contentData.links[buttonNr].includes("xthrust.com")) {
            return detailDescriptionIcons.xthrust_svg
        } else if (contentData.links[buttonNr].includes("paypal.com")) {
            return detailDescriptionIcons.paypal_svg
        } else if (contentData.links[buttonNr].includes("color") || contentData.links[buttonNr].includes("quantity")) {
            return detailDescriptionIcons.cart_svg
        } else if (contentData.links[buttonNr].includes("manuals")) {
            return detailDescriptionIcons.manual_svg
        } else {
            return detailDescriptionIcons.external_svg
        };
    };

    function addItemToCart() {

        //add detailWidgetAddToCartCountState x detailItemActiveRef.current to cart
        let cartContentTemp = [];

        if (!localStorage.getItem("cartContent")) {
            localStorage.setItem("cartContent", JSON.stringify(cartContentTemp));
        } else {
            cartContentTemp = JSON.parse(localStorage.getItem("cartContent"));
        };

        let color;

        if (detailWidgetColorState === "standard" && contentData.colors.length > 1) {
            color = contentData.colors[0];
        } else {
            color = detailWidgetColorState;
        };

        let foundItem = false;

        cartContentTemp.forEach((item, index) => {

            if (item.type === detailItemActiveRef.current && item.color === color) {

                foundItem = true;
                item.count = item.count + detailWidgetAddToCartCountState;

            };

        });

        if (foundItem === false) {

            cartContentTemp.push({
                type: detailItemActiveRef.current,
                color: color,
                price: contentData.price,
                weight: contentData.weight,
                htsclass: contentData.htsclass,
                count: detailWidgetAddToCartCountState
            });

        };

        localStorage.setItem("cartContent", JSON.stringify(cartContentTemp));
        setCartContent(cartContentTemp);

        setCheckoutPanelButtonState(true);

        //reset add to cart count after transaction and hide detail widget
        setDetailWidgetAddToCartCountState(1);
        setDetailWidgetState(false);

    }

    function detailWidgetCartNext() {

        if (detailWidgetState === "color") {

            setDetailWidgetState("quantity");

        } else if (detailWidgetState === "quantity") {

            addItemToCart();

        };

    };

    //touch and pointer interaction
    const touchStartXRef = useRef(0);
    const touchCurrentXRef = useRef(0);
    const touchEndXRef = useRef(0);
    const touchStartYRef = useRef(0);
    const touchCurrentYRef = useRef(0);
    const touchEndYRef = useRef(0);
        
    function checkDirection() {
        if (touchEndXRef.current < touchStartXRef.current && touchStartXRef.current - touchEndXRef.current > 75) {
            goToNextMedia();
        };
        if (touchEndXRef.current > touchStartXRef.current && touchEndXRef.current - touchStartXRef.current > 75) {
            goToPreviousMedia();
        };
    };

    function checkDirectionX(startX, endX, startY, endY) {
        let distanceX = 0;
        let distanceY = 0;

        if (startX > endX) {
            distanceX = startX - endX;
        } else {
            distanceX = endX - startX;
        };
            
        if (startY > endY) {
            distanceY = startY - endY;
        } else {
            distanceY = endY - startY;
        };
            
        if (distanceX > distanceY) {
            return true;
        } else {
            return false;
        };

    };

    function toggleVideoStatus() {

        if (detailWidgetState === false && widgetState === false) {
            if (mediaTopRef.current.tagName === "VIDEO") {
                if (mediaTopRef.current.paused) {
                    mediaTopRef.current.play();
                    setDetailPlayButtonState(false);
                } else {
                    mediaTopRef.current.pause();
                    setDetailPlayButtonState(true);
                };
            };
        } else {
            setDetailWidgetState(false);
            setWidgetState(false);
        };

        handleMenu("collapse");
        handleContactContainer("collapse");

    };

    function touchStart(e) {
        touchStartXRef.current = e.changedTouches[0].screenX;
        touchStartYRef.current = e.changedTouches[0].screenY;
    };

    function touchMove(e) {
        touchCurrentXRef.current = e.changedTouches[0].screenX;
        touchCurrentYRef.current = e.changedTouches[0].screenY;
        if (checkDirectionX(touchStartXRef.current, touchCurrentXRef.current, touchStartYRef.current, touchCurrentYRef.current)) {
            document.body.style.overflow = 'hidden';
        };
    };

    function touchEnd(e) {
        touchEndXRef.current = e.changedTouches[0].screenX;
        touchEndYRef.current = e.changedTouches[0].screenY;
        document.body.style.overflow = 'visible';
        if (checkDirectionX(touchStartXRef.current, touchEndXRef.current, touchStartYRef.current, touchEndYRef.current)) {
            checkDirection();
        };
    };
    

    function handleScroll() {

        if (getScrollPosition() < 0.9) {

            if (mediaTopRef.current.tagName === "VIDEO" && !mediaTopRef.current.paused) {
                toggleVideoStatus();
            };
        };

    };

    function handleResize() {

        updateDetailControlsSideState();
        setDetailWidgetWidthCorrState(getWidgetWidthCorr());

    };

    function handleMediaTopVidEnded() {

        if (detailWidgetState === false) {
            setDetailPlayButtonState(true);
        };

    };

    function handleDescriptionButtonClick(detailWidgetLink) {

        if (detailWidgetLink === detailWidgetState || detailWidgetLink === widgetState) {
            setDetailWidgetState(false);
            setWidgetState(false);
        } else {
            handleMenu("collapse");
            handleContactContainer("collapse");
            if (detailWidgetLink.includes("https://")) { //WIP
                setWidgetState(detailWidgetLink);
                setDetailWidgetState(false);
            } else {
                setWidgetState(false);
                setDetailWidgetState(detailWidgetLink);
            };
        };
    };

    //useEffect on detailWidgetState change
    useEffect(() => {

        if (detailWidgetState !== false || widgetState !== false) {
            setDetailPlayButtonState(false);
        } else if (mediaTopRef.current.tagName === "VIDEO" && mediaTopRef.current.paused && mediaFadeRunningRef.current === false) {
            setDetailPlayButtonState(true);
        };

        updateDetailControlsSideState();
                                                                                                                                                // eslint-disable-next-line
    }, [detailWidgetState, widgetState]);

    //useEffect on page parameter or contentData change
    useEffect(() => {

        mediaIndexBottomRef.current = 0;
        mediaIndexTopRef.current = 0;

        setDetailMediaBottomStyleState(prevState => ({
            ...prevState,
            objectPosition: contentData.pos[mediaIndexBottomRef.current],
        }));

        setDetailMediaTopStyleState(prevState => ({
            ...prevState,
            objectPosition: contentData.pos[mediaIndexTopRef.current],
        }));

        setDetailWidgetState(false);
        setWidgetState(false);
        updatePlayButton();
        updateDetailControlsSideState();

        if (page === "store") {
            setDetailWidgetColorState(contentData.colors[0]);
        } else {
            setDetailWidgetColorState("standard");
        };

        window.addEventListener("scroll", handleScroll);
        window.addEventListener("resize", handleResize);

        return () => {

            window.removeEventListener("scroll", handleScroll);
            window.removeEventListener("resize", handleResize);

        };
                                                                                                                                                // eslint-disable-next-line
    }, [page, detailItemActiveRef.current]);

    //useEffect on mediaTop change
    useEffect(() => {

        let mediaTopRefLocal = mediaTopRef.current;

        if (mediaTopRef.current.tagName === "VIDEO") {
            mediaTopRef.current.load();
            mediaTopRef.current.addEventListener("ended", handleMediaTopVidEnded);
        };

        return () => {
    
            mediaTopRefLocal.removeEventListener("ended", handleMediaTopVidEnded);

        };
                                                                                                                                                // eslint-disable-next-line
    }, [mediaIndexTopRef.current]);

    return (
        <div id="detail_container" style={detailContainerStyleState}>
            <div id="detail_container_content" ref={detailContainerRef} onClick={toggleVideoStatus} onTouchStart={touchStart} onTouchMove={touchMove} onTouchEnd={touchEnd}>

                {contentData.srcs[mediaIndexBottomRef.current].split('.').pop().toLowerCase() === "webp"
                    ?
                    <img    id="detail_media_bottom" 
                            style={detailMediaBottomStyleState} 
                            ref={mediaBottomRef} 
                            alt={contentData.srcs[mediaIndexBottomRef.current].replaceAll("/media/", "")} 
                            src={contentData.srcs[mediaIndexBottomRef.current]} 
                    />
                    :
                    <img    id="detail_media_bottom" 
                            style={detailMediaBottomStyleState} 
                            ref={mediaBottomRef} 
                            alt={contentData.srcs[mediaIndexBottomRef.current].replaceAll("mp4", "webp").replaceAll("/media/", "")} 
                            src={contentData.srcs[mediaIndexBottomRef.current].replaceAll("mp4", "webp")} 
                    />
                }

                {contentData.srcs[mediaIndexTopRef.current].split('.').pop().toLowerCase() === "webp"
                    ?
                    <img    id="detail_media_top" 
                            style={detailMediaTopStyleState} 
                            ref={mediaTopRef} 
                            alt={contentData.srcs[mediaIndexTopRef.current].replaceAll("/media/", "")} 
                            src={contentData.srcs[mediaIndexTopRef.current]} 
                            onLoad={() => {handleDetailOnLoad()}} 
                    />
                    :
                    <video  id="detail_media_top" 
                            src={contentData.srcs[mediaIndexTopRef.current]} 
                            style={detailMediaTopStyleState} 
                            ref={mediaTopRef} 
                            poster={contentData.srcs[mediaIndexTopRef.current].replaceAll("mp4", "webp")} 
                            playsInline 
                            onLoadedData={() => {handleDetailOnLoad()}} 
                    />
                }

                {detailPlayButtonState === true ? detailPlayButton : null}
            </div>
            <div id="description_container">
                <svg version="1.1" id="description_bg_svg" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 450 280" preserveAspectRatio="xMaxYMin meet" pointerEvents="none">
                    <path id="description_bg" fill="#000000" opacity="0.75" d="M450,280V14H210.65c-3.85,0-8.573,2.729-10.5,6.063L50.075,280H450z" pointerEvents="auto"/>
                </svg>
                <div id="description_text_container">
                    <div id="description_shape_left"></div>
                    <div id="description_shape_right"></div>
                    <div id="description_title">{contentData.title}</div>
                    {contentData.text}
                </div>
                <svg version="1.1" id="description_buttons_svg" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 450 280" preserveAspectRatio="xMaxYMin meet" pointerEvents="none">
                    {(() => {
                        if (contentData.links.length === 0) {
                            return (
                                <g>
                                    <path id="button_bar_none" opacity="0.75" fill="#333333" d="M50.075,280L194.413,30h-41c-3.852,0-8.575,2.729-10.501,6.063L2.057,280H50.075z"/>
                                </g>
                            )
                        } else if (contentData.links.length === 1) {
                            return (
                                <g>
                                    <path id="button_bar_one" opacity="0.75" fill="#333333" d="M50.075,280L165.546,80h-48.004L2.057,280H50.075z"/>
                                    <path   id="description_button_first" 
                                            opacity="0.75" 
                                            fill={descriptionButtonFirstFillState} 
                                            d="M166.738,77.936L194.413,30h-41c-3.852,0-8.575,2.729-10.501,6.063L118.696,78L166.738,77.936z" 
                                            pointerEvents="auto" 
                                            onPointerDown={() => {setDescriptionButtonFirstFillState("#B2B2B2")}} 
                                            onPointerUp={() => {setDescriptionButtonFirstFillState("#333333")}} 
                                            onPointerLeave={() => {setDescriptionButtonFirstFillState("#333333")}} 
                                            onTouchStart={() => {setDescriptionButtonFirstFillState("#B2B2B2")}} 
                                            onTouchEnd={() => {setDescriptionButtonFirstFillState("#333333")}} 
                                            onClick={() => {handleDescriptionButtonClick(contentData.links[0])}} 
                                    />
                                    <svg x="140.554px" y="38px" width="32px" height="32px" viewBox="0 0 32 32">
                                        {getDetailDescriptionIcon(0)}
                                    </svg>
                                </g>
                            )
                        } else if (contentData.links.length === 2) {
                            return (
                                <g>
                                    <path id="button_bar_two" opacity="0.75" fill="#333333" d="M50.075,280l86.603-150H88.671L2.057,280H50.075z"/>
                                    <path   id="description_button_first" 
                                            opacity="0.75" 
                                            fill={descriptionButtonFirstFillState} 
                                            d="M166.738,77.936L194.413,30h-41c-3.852,0-8.575,2.729-10.501,6.063L118.696,78L166.738,77.936z" 
                                            pointerEvents="auto" 
                                            onPointerDown={() => {setDescriptionButtonFirstFillState("#B2B2B2")}} 
                                            onPointerUp={() => {setDescriptionButtonFirstFillState("#333333")}} 
                                            onPointerLeave={() => {setDescriptionButtonFirstFillState("#333333")}} 
                                            onTouchStart={() => {setDescriptionButtonFirstFillState("#B2B2B2")}} 
                                            onTouchEnd={() => {setDescriptionButtonFirstFillState("#333333")}} 
                                            onClick={() => {handleDescriptionButtonClick(contentData.links[0])}}
                                    />
                                    <svg x="140.554px" y="38px" width="32px" height="32px" viewBox="0 0 32 32">
                                        {getDetailDescriptionIcon(0)}
                                    </svg>
                                    <path   id="description_button_second" 
                                            opacity="0.75" 
                                            fill={descriptionButtonSecondFillState} 
                                            d="M137.833,128l27.713-48h-48.004l-27.717,48H137.833z" 
                                            pointerEvents="auto" 
                                            onPointerDown={() => {setDescriptionButtonSecondFillState("#B2B2B2")}} 
                                            onPointerUp={() => {setDescriptionButtonSecondFillState("#333333")}} 
                                            onPointerLeave={() => {setDescriptionButtonSecondFillState("#333333")}} 
                                            onTouchStart={() => {setDescriptionButtonSecondFillState("#B2B2B2")}} 
                                            onTouchEnd={() => {setDescriptionButtonSecondFillState("#333333")}} 
                                            onClick={() => {handleDescriptionButtonClick(contentData.links[1])}}
                                    />
                                    <svg x="111.687px" y="88px" width="32px" height="32px" viewBox="0 0 32 32">
                                        {getDetailDescriptionIcon(1)}
                                    </svg>
                                </g>
                            )
                        } else if (contentData.links.length === 3) {
                            return (
                                <g>
                                    <path id="description_button_bar_three" opacity="0.75" fill="#333333" d="M50.075,280l57.735-100H59.8L2.057,280H50.075z"/>
                                    <path   id="description_button_first" 
                                            opacity="0.75" 
                                            fill={descriptionButtonFirstFillState} 
                                            d="M166.738,77.936L194.413,30h-41c-3.852,0-8.575,2.729-10.501,6.063L118.696,78L166.738,77.936z" 
                                            pointerEvents="auto" 
                                            onPointerDown={() => {setDescriptionButtonFirstFillState("#B2B2B2")}} 
                                            onPointerUp={() => {setDescriptionButtonFirstFillState("#333333")}} 
                                            onPointerLeave={() => {setDescriptionButtonFirstFillState("#333333")}} 
                                            onTouchStart={() => {setDescriptionButtonFirstFillState("#B2B2B2")}} 
                                            onTouchEnd={() => {setDescriptionButtonFirstFillState("#333333")}} 
                                            onClick={() => {handleDescriptionButtonClick(contentData.links[0])}}
                                    />
                                    <svg x="140.554px" y="38px" width="32px" height="32px" viewBox="0 0 32 32">
                                        {getDetailDescriptionIcon(0)}
                                    </svg>
                                    <path   id="description_button_second" 
                                            opacity="0.75" 
                                            fill={descriptionButtonSecondFillState} 
                                            d="M137.833,128l27.713-48h-48.004l-27.717,48H137.833z" 
                                            pointerEvents="auto" 
                                            onPointerDown={() => {setDescriptionButtonSecondFillState("#B2B2B2")}} 
                                            onPointerUp={() => {setDescriptionButtonSecondFillState("#333333")}} 
                                            onPointerLeave={() => {setDescriptionButtonSecondFillState("#333333")}} 
                                            onTouchStart={() => {setDescriptionButtonSecondFillState("#B2B2B2")}} 
                                            onTouchEnd={() => {setDescriptionButtonSecondFillState("#333333")}} 
                                            onClick={() => {handleDescriptionButtonClick(contentData.links[1])}}
                                    />
                                    <svg x="111.687px" y="88px" width="32px" height="32px" viewBox="0 0 32 32">
                                        {getDetailDescriptionIcon(1)}
                                    </svg>
                                    <path   id="description_button_third" 
                                            opacity="0.75" 
                                            fill={descriptionButtonThirdFillState} 
                                            d="M108.965,178l27.713-48H88.671l-27.717,48H108.965z" 
                                            pointerEvents="auto" 
                                            onPointerDown={() => {setDescriptionButtonThirdFillState("#B2B2B2")}} 
                                            onPointerUp={() => {setDescriptionButtonThirdFillState("#333333")}} 
                                            onPointerLeave={() => {setDescriptionButtonThirdFillState("#333333")}} 
                                            onTouchStart={() => {setDescriptionButtonThirdFillState("#B2B2B2")}} 
                                            onTouchEnd={() => {setDescriptionButtonThirdFillState("#333333")}} 
                                            onClick={() => {handleDescriptionButtonClick(contentData.links[2])}}
                                    />
                                    <svg x="82.819px" y="138px" width="32px" height="32px" viewBox="0 0 32 32">
                                        {getDetailDescriptionIcon(2)}
                                    </svg>
                                </g>
                            )
                        }
                    })()}
                </svg>
            </div>
            {detailControlsSideState === true ? 
                <div id="detail_controls_side_container">
                    <svg version="1.1" id="detail_controls_left_svg" style={detailControlsLeftSvgStyleState} xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 48 48" preserveAspectRatio="xMinYMid meet" pointerEvents="none">
                        <path id="detail_controls_left" fill="#FFFFFF" d="M16.825,22.003c-1.1,1.101-1.1,2.896,0,3.995l14.079,14.079c1.098,1.1,1.428,0.857,0.734-0.531l-6.514-13.02c-0.691-1.391-0.691-3.664,0-5.052l6.514-13.022c0.69-1.39,0.361-1.628-0.734-0.526L16.825,22.003z"/>
                        <rect id="detail_controls_left_button" opacity="0" x="0" y="0" width="48" height="48" pointerEvents="auto" onClick={() => {goToPreviousMedia()}}/>
                    </svg>
                    <svg version="1.1" id="detail_controls_right_svg" style={detailControlsRightSvgStyleState} xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 48 48" preserveAspectRatio="xMaxYMid meet" pointerEvents="none">
                        <path id="detail_controls_right" fill="#FFFFFF" d="M31.175,25.997c1.1-1.1,1.1-2.896,0-3.995L17.096,7.923c-1.098-1.1-1.428-0.857-0.734,0.531l6.514,13.02c0.691,1.391,0.691,3.664,0,5.051l-6.514,13.022c-0.69,1.39-0.361,1.628,0.734,0.526L31.175,25.997z"/>
                        <rect id="detail_controls_right_button" opacity="0" x="0" y="0" width="48" height="48" pointerEvents="auto" onClick={() => {goToNextMedia()}}/>
                    </svg>
                </div>
            : null}
            {contentData.srcs.length > 1 ? 
            <div id="detail_controls_items_container" style={detailControlsItemsContainerStyleState}>
                {
                    contentData.srcs.map((value, index)=>{
                        return(
                            <svg version="1.1" key={index} id="detail_controls_item_svg" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 20 20" preserveAspectRatio="xMidYMid meet" pointerEvents="none">
                                <rect id="detail_controls_item" opacity="0" x="0" y="0" width="20" height="20" pointerEvents="auto" onClick={() => {goToMediaIndex(index, "items")}}/>
                                <circle id="detail_controls_item_dot" fill="#FFFFFF" cx="10" cy="10" r={mediaIndexBottomRef.current === index ? "4" : "2"}/>
                            </svg>
                        )
                    })
                }
            </div>
            : null}
            {detailWidgetState !== false ? 
                <div id="detail_widget" style={detailWidgetStyleState}>
                    <div id="detail_widget_content" style={{width: (480 - detailWidgetWidthCorrState * 2) + "px"}}>
                        <svg version="1.1" id="detail_widget_svg" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 480 192" preserveAspectRatio="xMinYMin meet" pointerEvents="none">
                            <path id="detail_widget_bg" fill="#000000" opacity="0.75" d={"M" + (417.574 - detailWidgetWidthCorrState) + ",192c3.85,0,8.575-2.728,10.5-6.063l48.426-83.875C" + (478.425 - detailWidgetWidthCorrState) + ",98.728," + (480 - detailWidgetWidthCorrState) + ",92.85," + (480 - detailWidgetWidthCorrState) + ",89V7c0-3.85-3.15-7-7-7H" + (62.426 + detailWidgetWidthCorrState) + "c-3.85,0-8.575,2.728-10.5,6.062L" + (3.5 + detailWidgetWidthCorrState) + ",89.938C" + (1.575 + detailWidgetWidthCorrState) + ",93.272," + (0 + detailWidgetWidthCorrState) + ",99.15," + (0 + detailWidgetWidthCorrState) + ",103v82c0,3.85,3.15,7,7,7H" + (417.574 - detailWidgetWidthCorrState) + "z"} pointerEvents="auto"/>
                            <g transform={"translate(-" + detailWidgetWidthCorrState + " 0)"}>
                                <rect id="detail_widget_close_bg" x="444" fill="#000000" opacity="0" width="36" height="36" pointerEvents="auto" onClick={() => {setDetailWidgetState(false)}}/>
                                <polygon id="detail_widget_close_icon" fill="#FFFFFF" points="456.938,24.75 462,19.688 467.063,24.75 468.75,23.063 463.688,18 468.75,12.938 467.063,11.25 462,16.313 456.938,11.25 455.25,12.938 460.313,18 455.25,23.063 " pointerEvents="none"/>
                            </g>
                        </svg>
                        {(() => {
                            if (detailWidgetState === "color") {
                                return (
                                    <div id="detail_widget_text">
                                        <div id="detail_widget_text_title">select color</div>
                                        <div id="detail_widget_color_container">
                                            {
                                                contentData.colors.map((value, index)=>{
                                                    return(
                                                        <svg version="1.1" key={index} id="detail_widget_color_field_svg" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 36 36" pointerEvents="none">
                                                            <defs>
                                                                <linearGradient id="gradient_silver" gradientTransform="rotate(45) translate(0.2, 0.2)">
	                                                                <stop offset="0%" stopColor="#6D6D6D"/>
	                                                                <stop offset="50%" stopColor="#C8C8C8"/>
	                                                                <stop offset="100%" stopColor="#6D6D6D"/>
                                                                </linearGradient>
                                                            </defs>
                                                            <circle id="detail_widget_color_field_bg" fill="#333333" cx="18" cy="18" r="18"/>
                                                            <circle id="detail_widget_color_field_bg" fill={(() => {
                                                                if (value === "silver") {
                                                                    return "url('#gradient_silver')"
                                                                } else if (value === "black") {
                                                                    return "#222222"
                                                                } else if (value === "lime") {
                                                                    return "#CCFF33"
                                                                };
                                                            })()} pointerEvents="auto" onClick = {() => {goToMediaIndex(index, "widget")}} cx="18" cy="18" r="16"/>
                                                            {value === detailWidgetColorState || (detailWidgetColorState === "standard" && index === 0) ? <path id="detail_widget_checkmark" fill="#FFFFFF" d="M16.813,26.26c-0.283,0-0.616-0.096-0.818-0.299l-6.347-6.348l1.517-1.517l5.358,5.359l7.974-13.808l1.857,1.073l-8.672,15.018C17.515,26.027,17.078,26.26,16.813,26.26z"/> : null}
                                                        </svg>
                                                    )
                                                })
                                            }
                                        </div>
                                        <div id="detail_widget_button_container">
                                            <div    id="detail_widget_button"
                                                    style={{backgroundColor: detailWidgetButtonFillState}}
                                                    onClick={() => {detailWidgetCartNext()}}
                                                    onPointerDown={() => {setDetailWidgetButtonFillState("#66666666")}}
                                                    onTouchStart={() => {setDetailWidgetButtonFillState("#66666666")}}
                                                    onPointerUp={() => {setDetailWidgetButtonFillState("#00000066")}}
                                                    onPointerLeave={() => {setDetailWidgetButtonFillState("#00000066")}}
                                                    onTouchEnd={() => {setDetailWidgetButtonFillState("#00000066")}}
                                            >
                                                <div id="detail_widget_text_button">next</div>
                                            </div>
                                        </div>
                                    </div>
                                )
                            } else if (detailWidgetState === "quantity") {
                                return (
                                    <div id="detail_widget_text">
                                        <div id="detail_widget_text_title">select quantity</div>
                                        <div id="detail_widget_quantity_container">
                                            <svg version="1.1" id="detail_widget_minus_svg" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 36 36" pointerEvents="none">
                                                <rect id="detail_widget_minus_bg" fill="#000000" opacity="0" width="36" height="36" pointerEvents="auto" onClick = {() => {setDetailWidgetAddToCartCountState(Math.max(detailWidgetAddToCartCountState - 1, 1))}}/>
                                                <rect id="detail_widget_minus_icon" x="9.647" y="16.807" fill="#FFFFFF" width="16.705" height="2.387"/>
                                            </svg>
                                            <div id="detail_widget_text_cart_amount">{detailWidgetAddToCartCountState}</div>
                                            <svg version="1.1" id="detail_widget_plus_svg" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 36 36" pointerEvents="none">
                                                <rect id="detail_widget_plus_bg" fill="#000000" opacity="0" width="36" height="36" pointerEvents="auto" onClick = {() => {setDetailWidgetAddToCartCountState(Math.min(detailWidgetAddToCartCountState + 1, cartItemLimitRef.current))}}/>
                                                <polygon id="detail_widget_plus_icon" fill="#FFFFFF" points="26.353,19.193 26.353,16.807 19.193,16.807 19.193,9.647 16.807,9.647 16.808,16.807 9.647,16.807 9.647,19.193 16.807,19.193 16.807,26.353 19.193,26.353 19.193,19.193 "/>
                                            </svg>
                                        </div>
                                        <div id="detail_widget_button_container">
                                            <div    id="detail_widget_button"
                                                    style={{backgroundColor: detailWidgetButtonFillState}}
                                                    onClick={() => {detailWidgetCartNext()}}
                                                    onPointerDown={() => {setDetailWidgetButtonFillState("#66666666")}}
                                                    onTouchStart={() => {setDetailWidgetButtonFillState("#66666666")}}
                                                    onPointerUp={() => {setDetailWidgetButtonFillState("#00000066")}}
                                                    onPointerLeave={() => {setDetailWidgetButtonFillState("#00000066")}}
                                                    onTouchEnd={() => {setDetailWidgetButtonFillState("#00000066")}}
                                            >
                                                <div id="detail_widget_text_button">add to cart</div>
                                            </div>
                                        </div>
                                    </div>
                                )
                            }
                        })()}
                    </div>
                </div>
            : null}
        </div>
    );

};